import styled from "styled-components";

export const AdsSlotWrapper = styled.div<{ style?: any }>`
    display: unset !important;
    position: fixed !important;
    z-index: 9999 !important;
    left: 20px !important;
    bottom: 50px !important;
  ${({ style }) => style}
`;
